import { Page, View, Text, Image, Link } from "@react-pdf/renderer";
import SearchReportCover from "@assets/SearchReportCover.png";

import type { ReportMetadata, SearchContext } from "@appTypes/report";

import { styles } from "@hooks/useReport/reportModels/searchIndicatorReportModel/layout/styles";
import {
  Wordmark,
  Slogan,
  HumboldtLogo,
} from "@hooks/useReport/reportModels/searchIndicatorReportModel/layout/branding";
import { documentInfo } from "@hooks/useReport/reportModels/searchIndicatorReportModel/layout/documentInfo";
import { REPORT_PAGE_SIZE } from "@config/report";
import { LOCALE } from "@config/global";

export function CoverPage({
  context,
  metadata,
  indicatorsAmount,
}: {
  context: SearchContext;
  metadata: ReportMetadata;
  indicatorsAmount: number;
}) {
  return (
    <Page
      size={REPORT_PAGE_SIZE}
      style={styles.coverPage}
      bookmark={{
        title: documentInfo.coverPage.bookmarkTitle,
        fit: true,
      }}
    >
      <View style={styles.coverImageBox}>
        <Image src={SearchReportCover} style={styles.coverImage} />
      </View>

      <View style={styles.coverBody}>
        <Text style={styles.coverKicker}>{documentInfo.coverPage.subject}</Text>
        <Text style={styles.titleAreaType}>
          Consulta de {context.area.type}
        </Text>
        <Text style={styles.titleGeneral}>
          {context.area?.name
            ? context.area.name
            : `id: ${context.area.polygonId}`}
        </Text>

        <View style={styles.coverMetaRow}>
          <View style={styles.coverMetaItem}>
            <Text style={styles.coverMetaLabel}>
              {documentInfo.coverPage.madeInDate}
            </Text>
            <Text style={styles.coverMetaValue}>{metadata.creationDate}</Text>
          </View>
          <View style={styles.coverMetaItem}>
            <Text style={styles.coverMetaLabel}>
              {documentInfo.coverPage.madeInBy}
            </Text>
            <Text style={styles.coverMetaValue}>{metadata.madeBy.name}</Text>

            <Text style={styles.coverMetaLabel}>
              {documentInfo.coverPage.madeInByContact}
            </Text>
            <Text style={styles.coverMetaValue}>
              <Link
                src={`mailto:${metadata.madeBy.email}`}
                style={styles.coverMetaValue}
              >
                {metadata.madeBy.email}
              </Link>
            </Text>
          </View>
          <View style={styles.coverMetaItem}>
            <Text style={styles.coverMetaLabel}>
              {documentInfo.aboutSearch.stats.areaLabel}
            </Text>
            <Text style={styles.coverMetaValue}>
              {Math.round(context.area.size).toLocaleString(LOCALE)}
              {context.area.type ? (
                <Text style={styles.metricUnit}>
                  {documentInfo.aboutSearch.stats.areaUnit}
                </Text>
              ) : null}
            </Text>

            <Text style={styles.coverMetaLabel}>
              {documentInfo.coverPage.indicatorsAmount}
            </Text>
            <Text style={styles.coverMetaValue}>{indicatorsAmount}</Text>
          </View>
        </View>
      </View>

      <View style={styles.coverBrandRow}>
        <HumboldtLogo height={56} />
        <View style={{ alignItems: "flex-end" }}>
          <Wordmark />
          <Slogan />
        </View>
      </View>
    </Page>
  );
}
